import { IController, IComponentOptions, IOnChangesObject } from "angular";
import dayjs from "@gtmhub/dayjs";

export interface IOnUpdateParams {
  fieldName: string;
  cf: string;
}

export class CfDatepickerCtrl implements IController {
  field: {
    date: string;
    dateOriginal: string;
    dateObj: Date;
  };
  editMode: boolean;

  // bindings
  fieldName: string;
  targetValue: string;
  disabled: boolean;
  onUpdate: (params: IOnUpdateParams) => void;

  $onInit(): void {
    this.editMode = false;
    this.field = {
      date: this.targetValue,
      dateOriginal: this.targetValue,
      dateObj: this.targetValue === null || isNaN(Date.parse(this.targetValue)) ? new Date() : new Date(this.targetValue),
    };
  }

  $onChanges(onChangesObj: IOnChangesObject): void {
    if (
      onChangesObj &&
      onChangesObj.targetValue &&
      Object.keys(onChangesObj.targetValue.previousValue).length > 0 &&
      !isNaN(Date.parse(onChangesObj.targetValue.currentValue)) &&
      onChangesObj.targetValue.currentValue != onChangesObj.targetValue.previousValue
    ) {
      /*
       * targetValue for current datepicker has been changed in the parent scope.
       * Handle this change and make sure to sync this datepicker with the new targetValue.
       *
       * NOTE: in case when this datepicker dialog is opened,
       *       its related targetValue will be set to EMPTY_STRING: "",
       *       because of the openDatepicker and will trigger $onChanges,
       *       so we need to skipp this kind of change as it is within the current datepicker.
       *
       *       In case when the change is from outside this datepicker,
       *       the value of the targetValue should be proper Date formatted string
       *       which is checked in the isNaN check above
       *       and this.targetValue will be same as onChangesObj.targetValue.currentValue
       */
      this.setDate(new Date(onChangesObj.targetValue.currentValue));
    }
  }

  setDate(date: Date): void {
    const utcDate = date ? dayjs(date.setHours(0, 0, 0, 0)).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null;
    this.field.date = utcDate;

    if (this.field.dateOriginal !== this.field.date) {
      this.field.dateOriginal = this.field.date;

      if (this.field.dateOriginal !== null && !isNaN(Date.parse(this.field.dateOriginal))) {
        /*
         * Record the current date as Date entry - USED FOR FORM VALIDATION
         * NOTE: record ONLY not null values
         *       otherwise datepicker dialog will start from 01.01.1970
         */
        this.field.dateObj = new Date(this.field.dateOriginal);
      }

      this.onUpdate({ fieldName: this.fieldName, cf: this.field.date });
    }
  }

  openDatepicker($event: ng.IAngularEvent): void {
    this.toggleEditMode();
    this.setDate(null);
    $event.preventDefault();
    $event.stopPropagation();
  }

  toggleEditMode(state?: boolean): void {
    this.editMode = state === true || state === false ? state : !this.editMode;
  }
}

export const CfDatepickerComponent: IComponentOptions = {
  bindings: {
    fieldName: "@",
    targetValue: "@",
    disabled: "<",
    onUpdate: "&",
  },
  controller: CfDatepickerCtrl,
  templateUrl: require("./cf-datepicker.component.jade"),
};
